import { render, staticRenderFns } from "./ChartRunningWidgetSpeed.vue?vue&type=template&id=53752836&scoped=true&"
import script from "./ChartRunningWidgetSpeed.vue?vue&type=script&lang=ts&"
export * from "./ChartRunningWidgetSpeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53752836",
  null
  
)

export default component.exports